import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';

import { ModalHeader, ModalContent, ModalFooter } from 'app/components/shared/Modal';

export default function DeleteUgcForm({
  ugcType,
  catalogBib,
  id,
  removeUgcAction,
  handleClose,
  handleSuccess,
  isLoading
}) {
  function deleteUgc() {
    removeUgcAction({
      metadataId: catalogBib.get('metadataId'),
      [`${ugcType}Id`]: id,
      postSuccess: () => {
        handleClose();
        if (handleSuccess) handleSuccess();
      }
    });
  }

  return (
    <div className="cp-delete-ugc-form">
      <ModalHeader title={<FormattedMessage id={`delete_${ugcType}`} />} />
      <ModalContent>
        <FormattedMessage id={`delete_${ugcType}_confirmation`} />
      </ModalContent>
      <ModalFooter
        primaryActionButtonText={<FormattedMessage id="delete_button" />}
        primaryActionButtonTag={TransactionalSolidButton}
        handlePrimaryAction={deleteUgc}
        isLoading={isLoading}
      />
    </div>
  );
}

DeleteUgcForm.propTypes = {
  ugcType: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  removeUgcAction: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func
};
